import { FC, useState } from 'react'
import { BundleItemAmount, BundleItemButton, BundleItemHint, BundleItemSubtitle, BundleItemTitle, BundleItemWrapper } from './styles'
import { useProfileId } from 'core/auth'
import { useTranslation } from 'react-i18next'
import { getCurrentContextName } from 'supporting'
import { useToasts } from '@brg/ui'
import { useSelector } from 'react-redux'
import { selectorOrder } from '../../slices/OrderSlice'
import { FlorinIcon } from 'shared/icons/FlorinIcon/FlorinIcon'
import { buyBundleHandler } from '../helpers/buyBundleHandlers'
import { useModal } from 'core'
import useCurrency from 'shared/hooks/useCurrency'

interface ByndleBuy {
    currencyType: number
    amount: number
}

export interface Bundle {
    buyFor: ByndleBuy
    buyWhat: ByndleBuy
    description: string
    id: string
    title: string
}

interface BundleItemProps {
    bundle: Bundle
    close?: () => void
    competitionId?: string // ID конкурса для COPY_CARD flow
    selectedProjectId?: string // ID выбранного проекта для COPY_CARD flow
}

export const BundleItem: FC<BundleItemProps> = (props) => {
    const { t } = useTranslation()
    const { bundle, close, competitionId, selectedProjectId } = props
    const { title, description: subtitle, buyFor, buyWhat } = bundle || {}
    const cost = buyFor?.amount
    const amount = buyWhat?.amount
    const modal = useModal()

    const profileId = useProfileId()
    const { error } = useToasts();
    const [isBuying, setIsBuying] = useState(false)
    const order = useSelector(selectorOrder)
    const contextName = getCurrentContextName()
    const isZeland = false;
    const { convertCurrency, isRub } = useCurrency()

    const buyBundle = async () => {
        buyBundleHandler({ isBuying, close, profileId, error, t, bundle, setIsBuying, order, contextName, modal, competitionId, selectedProjectId })
    }

    return <BundleItemWrapper>
        <BundleItemTitle>{title}</BundleItemTitle>
        <BundleItemSubtitle>{subtitle}</BundleItemSubtitle>
        <BundleItemAmount>{amount} <FlorinIcon margin='8px' white={isZeland} black={!isZeland} size={53 / 15} mobileSize={28 / 15} /></BundleItemAmount>
        <BundleItemButton onClick={buyBundle} disabled={isBuying || !isRub}>
            {t('payment.buy_for')} {convertCurrency(cost)}</BundleItemButton>
        <BundleItemHint>{t('payment.will_redirect_to_pay')}</BundleItemHint>
    </BundleItemWrapper>
}
import { FC, useState } from 'react'
import { BundleItemAmount, BundleItemButton, BundleItemHint, BundleItemSubtitle, BundleItemTitle, BundleItemWrapper } from './styles'
import { useProfileId } from 'core/auth'
import { useTranslation } from 'react-i18next'
import { getCurrentContextName } from 'supporting'
import { useToasts } from '@brg/ui'
import { useSelector } from 'react-redux'
import { selectorOrder } from '../../slices/OrderSlice'
import { FlorinIcon } from 'shared/icons/FlorinIcon/FlorinIcon'
import { buyBundleHandler } from '../helpers/buyBundleHandlers'
import { useModal } from 'core'
import useCurrency from 'shared/hooks/useCurrency'

interface ByndleBuy {
    currencyType: number
    amount: number
}

export interface Bundle {
    buyFor: ByndleBuy
    buyWhat: ByndleBuy
    description: string
    id: string
    title: string
}

interface BundleItemProps {
    bundle: Bundle
    close?: () => void
    competitionId?: string // ID конкурса для COPY_CARD flow
    selectedProjectId?: string // ID выбранного проекта для COPY_CARD flow
}

export const BundleItem: FC<BundleItemProps> = (props) => {
    const { t } = useTranslation()
    const { bundle, close, competitionId, selectedProjectId } = props
    const { title, description: subtitle, buyFor, buyWhat } = bundle || {}
    const cost = buyFor?.amount
    const amount = buyWhat?.amount
    const modal = useModal()

    const profileId = useProfileId()
    const { error } = useToasts();
    const [isBuying, setIsBuying] = useState(false)
    const order = useSelector(selectorOrder)
    const contextName = getCurrentContextName()
    const isZeland = false;
    const { convertCurrency, isRub } = useCurrency()

    const buyBundle = async () => {
        buyBundleHandler({ isBuying, close, profileId, error, t, bundle, setIsBuying, order, contextName, modal, competitionId, selectedProjectId })
    }

    return <BundleItemWrapper>
        <BundleItemTitle>{title}</BundleItemTitle>
        <BundleItemSubtitle>{subtitle}</BundleItemSubtitle>
        <BundleItemAmount>{amount} <FlorinIcon margin='8px' white={isZeland} black={!isZeland} size={53 / 15} mobileSize={28 / 15} /></BundleItemAmount>
        <BundleItemButton onClick={buyBundle} disabled={isBuying || !isRub}>
            {t('payment.buy_for')} {convertCurrency(cost)}</BundleItemButton>
        <BundleItemHint>{t('payment.will_redirect_to_pay')}</BundleItemHint>
    </BundleItemWrapper>
}
